import { useIonRouter, useIonViewDidLeave } from '@ionic/react';
import { Button } from '@up2stay/up2promo-ui';
import { motion } from 'motion/react';
import { useState } from 'react';

import { useDictionary } from '@/core/providers/dictionary-provider';

import { WelcomeSlideshow } from './welcome-slideshow';

const containerVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1] as const,
    },
  },
};

export function WelcomeScreen() {
  const dict = useDictionary();
  const router = useIonRouter();
  const [skipEnterAnimation, setSkipEnterAnimation] = useState(false);

  useIonViewDidLeave(() => {
    setSkipEnterAnimation(true);
  });

  const handleGetStarted = () => {
    router.push('/auth', 'forward', 'push');
  };

  return (
    <div className="flex h-full w-full flex-col items-center justify-center overflow-hidden px-4 sm:px-6">
      <motion.div
        variants={containerVariants}
        initial={skipEnterAnimation ? false : 'hidden'}
        animate="visible"
        className="flex h-full w-full max-w-md flex-col gap-4"
      >
        <div className="flex-shrink-0 flex flex-col gap-3 py-4 pt-12 text-left md:text-center">
          <h1 className="text-[26px] font-bold leading-[1.1] tracking-tight text-foreground">
            {dict.welcome.title}
          </h1>
        </div>

        <div className="flex min-h-0 flex-1 flex-col gap-3 overflow-hidden">
          <p className="flex-shrink-0 text-[15.5px] font-bold leading-tight text-foreground text-left md:text-center">
            {dict.welcome.slidesTitle}
          </p>
          <div className="flex min-h-0 flex-1 overflow-hidden">
            <WelcomeSlideshow />
          </div>
        </div>

        <div className="flex-shrink-0 py-2">
          <Button
            onClick={handleGetStarted}
            variant="primary"
            size="xl"
            radius="full"
            className="w-full font-semibold"
          >
            {dict.welcome.button}
          </Button>
        </div>
      </motion.div>
    </div>
  );
}
